import { PrimaryConnectionTarget } from "./model.ts";
import * as Schema from "effect/Schema";

/** The environment this client connects to. */
export interface ConnectionCatalogEntry {
  readonly target: PrimaryConnectionTarget;
}

export class PrimaryConnectionRegistration extends Schema.TaggedClass<PrimaryConnectionRegistration>()(
  "PrimaryConnectionRegistration",
  {
    target: PrimaryConnectionTarget,
  },
) {}
